import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kmsz",
  "use": "icon-kmsz-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-kmsz\">\n<g id=\"icon-kmsz_Menu/kmsz\">\n<g id=\"icon-kmsz_Icon/kmsz\">\n<path id=\"icon-kmsz_fork\" d=\"M6 2.5C6 2.22386 6.22386 2 6.5 2H9.5C9.77614 2 10 2.22386 10 2.5V5.5C10 5.77614 9.77614 6 9.5 6H8.5V8H11.5C12.0523 8 12.5 8.44772 12.5 9V10H13.5C13.7761 10 14 10.2239 14 10.5V13.5C14 13.7761 13.7761 14 13.5 14H10.5C10.2239 14 10 13.7761 10 13.5V10.5C10 10.2239 10.2239 10 10.5 10H11.5V9H4.5V10H5.5C5.77614 10 6 10.2239 6 10.5V13.5C6 13.7761 5.77614 14 5.5 14H2.5C2.22386 14 2 13.7761 2 13.5V10.5C2 10.2239 2.22386 10 2.5 10H3.5V9C3.5 8.44772 3.94772 8 4.5 8H7.5V6H6.5C6.22386 6 6 5.77614 6 5.5V2.5ZM7 5H9V3H7V5ZM3 11V13H5V11H3ZM11 11V13H13V11H11Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/kmsz.svg
// module id = E+w6
// module chunks = 140